import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { FieldInput } from "../../../../components/FieldInput";
import { FIELDS } from "./CONSTANT";

export default function FineForm({ validation }) {  
  return (
    <Row>
      <Col md={12}>
        <Card>
          <CardBody>
            <Row>
              {FIELDS.map((f) => (
                <FieldInput key={f.key} f={f} validation={validation} />
              ))}
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
